import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant", "upgradeSource"],
  _excluded2 = ["children", "upgradeSource"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
import { Button, Link } from 'breeze-intelligence-kit';
import { UpgradeIcon } from 'foundations-assets';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useOnUpgrade = upgradeSource => {
  const {
    openUpgradePage: onUpgrade
  } = useUpgradePoint(upgradeSource);
  return {
    onUpgrade
  };
};
export const UpgradeLink = _ref => {
  let {
      children,
      variant = 'on-dark',
      upgradeSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, rest, {
    onClick: onUpgrade,
    use: variant,
    children: children
  }));
};
export const UpgradeButton = _ref2 => {
  let {
      children,
      upgradeSource
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    onClick: onUpgrade,
    children: children
  }));
};

/**
 * @todo Update intelligence tab to use UpgradeButtonIcon and migrate
 * to use UpgradeLinkIcon.
 */
export const UpgradeLinkIcon = _ref3 => {
  let {
      children
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(UpgradeLink, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(Button.Icon, {
      children: /*#__PURE__*/_jsx(UpgradeIcon, {})
    }), children]
  }));
};
export const UpgradeButtonIcon = _ref4 => {
  let {
      children
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(UpgradeButton, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(Button.Icon, {
      children: /*#__PURE__*/_jsx(UpgradeIcon, {})
    }), children]
  }));
};